import React from 'react';
import { Printer, X, Download, Image as ImageIcon } from 'lucide-react';
import html2canvas from 'html2canvas';

export default function ReceiptTemplate({ payment, liveShare, currentAnimal, onClose }) {
  const handlePrint = () => {
    window.print();
  };

  const handleWhatsAppShare = async () => {
    const element = document.getElementById('printable-receipt');
    if (!element) return;
    
    const originalBg = element.style.background;
    const actionsClone = document.createElement('div');
    element.style.background = 'white';
    
    // Yükleniyor durumu eklenebilir ama işlem hızlı sürecektir.
    try {
       const canvas = await html2canvas(element, { scale: 2, useCORS: true });
       
       canvas.toBlob(async (blob) => {
          if (!blob) return;
          const file = new File([blob], `Makbuz-${receiptNo}.png`, { type: 'image/png' });
          
          // 1. MOBİL CİHAZ KONTROLÜ (Native Share)
          if (navigator.canShare && navigator.canShare({ files: [file] })) {
             try {
                await navigator.share({
                   files: [file],
                   title: 'Tahsilat Makbuzu',
                   text: `${liveShare?.customerFirstName} ${liveShare?.customerLastName} - Haşimoğlu Çiftliği Tahsilat Makbuzu`
                });
                return; // Mobilde işlem başarıyla bitti
             } catch (shareErr) {
                console.log("Mobil paylaşım iptal edildi veya desteklenmiyor", shareErr);
             }
          }
          
          // 2. MASAÜSTÜ BİLGİSAYAR KONTROLÜ (Clipboard Kopyalama + WhatsApp Web)
          try {
             const clipboardItem = new window.ClipboardItem({ 'image/png': blob });
             if (navigator.clipboard && navigator.clipboard.write) {
               await navigator.clipboard.write([clipboardItem]);
               alert("Görsel hafızaya kopyalandı!\n\nŞimdi arka planda açılacak olan WhatsApp şablonunda 'CTRL+V' (Sağ Tık -> Yapıştır) yaparak makbuzu gönderebilirsiniz.");
             } else {
               // Clipboard desteği yoksa sadece indir
               throw new Error("Clipboard API desteklenmiyor");
             }
          } catch (clipErr) {
             console.log("Panoya kopyalama başarısız, normal indirmeye geçiliyor", clipErr);
             alert("Tarayıcınız otomatik kopyalamayı desteklemiyor. Makbuz şimdi indirilecek, ardından WhatsApp'a manuel yükleyebilirsiniz.");
             // Fallback: İndirme işlemi
             const link = document.createElement('a');
             link.download = `Makbuz-${receiptNo}.png`;
             link.href = URL.createObjectURL(blob);
             link.click();
             return;
          }
          
          // Telefona Özel WhatsApp Linkini Aç (Sadece Masaüstü Clipboard akışından geldiysek çalışır)
          // Telefon formatlama
          let cleanPhone = liveShare?.customerPhone?.replace(/\D/g, '') || '';
          if (cleanPhone.startsWith('0')) cleanPhone = cleanPhone.substring(1);
          if (!cleanPhone.startsWith('90')) cleanPhone = `90${cleanPhone}`;
          
          const text = "Merhaba, Haşimoğlu Çiftliğinden yazıyoruz. Tahsilat işleminize ait kurban makbuzunuz ektedir.\n\nDurumunuzu anlık takip etmek için:\nhttps://hasimoglucifligi.com";
          const waLink = `https://wa.me/${cleanPhone}?text=${encodeURIComponent(text)}`;
          window.open(waLink, '_blank');
          
       }, 'image/png');
       
    } catch (err) {
       console.error("Görsel oluşturma hatası:", err);
       alert("Makbuz resme dönüştürülürken bir hata oluştu.");
    } finally {
       element.style.background = originalBg;
    }
  };

  const receiptNo = payment?.receiptNo || 'MKBZ-YOK';
  const formattedDate = (payment?.createdAt?.toDate && typeof payment.createdAt.toDate === 'function') 
    ? payment.createdAt.toDate().toLocaleDateString('tr-TR') 
    : new Date().toLocaleDateString('tr-TR');
    
  // Fotoğraf Kontrolü (Varsa hayvanın fotoğrafı, yoksa jenerik kurban fotoğrafı)
  const animalImage = currentAnimal?.photoUrl 
     ? currentAnimal.photoUrl 
     : '/images/kurban_placeholder.png';
  
  return (
    <div className="fixed inset-0 z-[100] flex items-start sm:items-center justify-start sm:justify-center bg-black/80 backdrop-blur-sm overflow-auto p-4 py-12">
       <style>{`
          @media print {
            body * {
               visibility: hidden;
            }
            #printable-receipt, #printable-receipt * {
               visibility: visible;
            }
            #printable-receipt {
               position: absolute;
               left: 0;
               top: 0;
               width: 100%;
               margin: 0;
               padding: 20px;
               background: white !important;
            }
            .no-print {
               display: none !important;
            }
          }
       `}</style>
       
       
       <div className="flex flex-col items-center min-w-max md:min-w-0 mx-auto">
          {/* ACTION BAR (Her zaman ustte sabit durabilir veya eklenebilir) */}
          <div className="sticky top-0 z-[110] bg-white/90 backdrop-blur-md px-6 py-4 rounded-xl shadow-lg border border-gray-200 mb-6 flex flex-col sm:flex-row justify-between items-center gap-4 w-full max-w-[800px]">
             <h2 className="text-lg font-bold text-navy-900">Makbuz Önizleme</h2>
             <div className="flex flex-wrap items-center justify-center gap-2">
                <button onClick={handleWhatsAppShare} className="flex items-center gap-2 bg-forest-600 hover:bg-forest-500 text-white px-4 py-2 rounded-lg font-bold transition-colors shadow-lg text-sm">
                   <Download className="w-4 h-4" /> Whatsapp'tan Gönder (Görsel)
                </button>
                <button onClick={handlePrint} className="flex items-center gap-2 bg-navy-900 hover:bg-navy-800 text-white px-4 py-2 rounded-lg font-bold transition-colors text-sm">
                   <Printer className="w-4 h-4" /> Yazdır / PDF
                </button>
                <button onClick={onClose} className="flex items-center justify-center bg-gray-200 hover:bg-gray-300 text-gray-700 w-10 h-10 rounded-lg transition-colors border border-gray-300 shrink-0">
                   <X className="w-5 h-5" />
                </button>
             </div>
          </div>

          <div className="relative w-[800px] min-w-[800px] bg-white text-navy-950 rounded-lg shadow-2xl p-8 mb-8" id="printable-receipt">

          {/* DOCUMENT HEADER */}
          <div className="flex justify-between items-start border-b-2 border-navy-900 pb-6 mb-6">
             <div className="flex items-center gap-4">
                <div className="w-16 h-16 flex items-center justify-center bg-navy-50 rounded-lg shrink-0 overflow-hidden p-1">
                   <img crossOrigin="anonymous" src="/angry-bull-logo.png" alt="Haşimoğlu Logo" className="w-full h-full object-contain" />
                </div>
                <div>
                  <h1 className="text-2xl font-black text-navy-900 tracking-tight uppercase">HAŞİMOĞLU ÇİFTLİĞİ</h1>
                  <p className="text-xs font-semibold text-navy-600 tracking-wider">GÜVENİLİR KURBANLIK VE HAYVANCILIK YÖNETİMİ</p>
                </div>
             </div>
             <div className="text-right">
                <h2 className="text-2xl font-black text-navy-900/10 uppercase mb-1">TAHSİLAT MAKBUZU</h2>
                <div className="inline-block bg-navy-50 px-3 py-1.5 rounded border border-navy-200">
                   <p className="text-xs font-bold text-navy-600 mb-0.5">TARİH: <span className="text-navy-900 font-mono">{formattedDate}</span></p>
                   <p className="text-xs font-bold text-navy-600">MAKBUZ NO: <span className="text-navy-900 font-mono">{receiptNo}</span></p>
                </div>
             </div>
          </div>

          {/* CUSTOMER & ANIMAL INFO WITH IMAGE */}
          <div className="flex gap-6 mb-8">
             <div className="flex-1 grid grid-cols-2 gap-6">
                 <div>
                    <h3 className="text-[10px] font-bold tracking-widest text-navy-400 uppercase mb-2">Müşteri Bilgileri</h3>
                    <div className="bg-navy-50 p-4 rounded-lg border border-navy-100 h-[100px]">
                       <p className="font-bold text-navy-900 text-lg mb-1 capitalize line-clamp-1">{liveShare?.customerFirstName} {liveShare?.customerLastName}</p>
                       <p className="text-sm text-navy-700 font-mono">{liveShare?.customerPhone}</p>
                       <p className="text-xs text-navy-500 mt-2 font-bold bg-navy-100 inline-block px-2 py-0.5 rounded">Hisse Adedi: {liveShare?.shareWeight || 1}</p>
                    </div>
                 </div>
                 <div>
                    <h3 className="text-[10px] font-bold tracking-widest text-navy-400 uppercase mb-2">Kurban Bilgileri</h3>
                    <div className="bg-navy-50 p-4 rounded-lg border border-navy-100 h-[100px]">
                       {currentAnimal ? (
                          <div className="space-y-1.5">
                             <div className="flex justify-between"><span className="text-xs text-navy-600 font-bold">Şubesi:</span> <span className="text-xs text-navy-900 uppercase font-bold">{currentAnimal.branch}</span></div>
                             <div className="flex justify-between"><span className="text-xs text-navy-600 font-bold">Küpe No:</span> <span className="text-xs text-navy-900 font-bold">{currentAnimal.tagNo}</span></div>
                             <div className="flex justify-between"><span className="text-xs text-navy-600 font-bold">Kilo/Türü:</span> <span className="text-xs text-navy-900 font-bold">{currentAnimal.weight}kg {currentAnimal.type}</span></div>
                          </div>
                       ) : (
                          <p className="text-sm text-navy-500 italic mt-2">Kurban bilgisi bulunamadı.</p>
                       )}
                    </div>
                 </div>
             </div>
             <div className="w-32 shrink-0">
                <h3 className="text-[10px] font-bold tracking-widest text-navy-400 uppercase mb-2">Kurban Görseli</h3>
                <div className="w-32 h-[100px] bg-navy-50 rounded-lg border border-navy-200 overflow-hidden relative">
                   <img crossOrigin="anonymous" src={animalImage} alt="Kurban" className="w-full h-full object-cover" />
                   {!currentAnimal?.photoUrl && (
                      <div className="absolute inset-x-0 bottom-0 bg-black/60 text-white text-[8px] text-center py-0.5 font-bold">Temsili Görsel</div>
                   )}
                </div>
             </div>
          </div>

          {/* FINANCIAL DETAILS */}
          <div className="mb-10 border border-navy-200 rounded-lg overflow-hidden">
             <table className="w-full text-left text-sm">
                <thead className="bg-navy-900 text-white">
                   <tr>
                      <th className="px-4 py-3 font-bold text-xs tracking-wider border-r border-navy-800">AÇIKLAMA / İŞLEM DETAYI</th>
                      <th className="px-4 py-3 font-bold text-xs tracking-wider w-32 border-r border-navy-800">ÖDEME TÜRÜ</th>
                      <th className="px-4 py-3 font-bold text-xs tracking-wider text-right w-40">TUTAR</th>
                   </tr>
                </thead>
                <tbody className="divide-y divide-navy-100 bg-white">
                   <tr>
                      <td className="px-4 py-4 align-top border-r border-navy-100">
                         <p className="font-bold text-navy-900 text-sm">Kurbanlık Hisse Tahsilatı</p>
                         {payment?.description && (
                            <div className="bg-amber-50 border-l-2 border-amber-400 p-2 mt-2 rounded-r">
                               <p className="text-[11px] text-amber-900 italic font-mono pr-4 leading-tight">Ek Not: {payment.description}</p>
                            </div>
                         )}
                      </td>
                      <td className="px-4 py-4 align-top border-r border-navy-100">
                         <span className="inline-block bg-navy-100 text-navy-800 px-2 py-1 rounded text-[10px] font-bold uppercase tracking-wider whitespace-nowrap">
                            {payment?.type || 'Nakit'}
                         </span>
                      </td>
                      <td className="px-4 py-4 align-top text-right font-black text-xl text-navy-900 whitespace-nowrap bg-navy-50/50">
                         {payment?.amount?.toLocaleString('tr-TR')} ₺
                      </td>
                   </tr>
                </tbody>
             </table>
             <div className="bg-navy-50 p-4 border-t border-navy-200 flex justify-end">
                <div className="w-[300px] space-y-2">
                   <div className="flex justify-between text-sm">
                      <span className="text-navy-600 font-bold uppercase text-[10px] tracking-wider mt-1">Kalan Borç (Bakiye):</span>
                      <span className="text-navy-900 font-bold text-base">{((liveShare?.price || 0) - (liveShare?.paidAmount || 0)).toLocaleString('tr-TR')} ₺</span>
                   </div>
                   <div className="h-px w-full bg-navy-200 my-1"></div>
                   <div className="flex justify-between items-center rounded-lg bg-emerald-500/10 p-2 border border-emerald-500/20">
                      <span className="text-emerald-900 font-black text-xs uppercase tracking-wider">TAHSİL EDİLEN:</span>
                      <span className="text-emerald-700 font-black text-2xl">{payment?.amount?.toLocaleString('tr-TR')} ₺</span>
                   </div>
                </div>
             </div>
          </div>

          {/* SIGNATURES */}
          <div className="flex justify-between px-10 pt-4">
             <div className="text-center">
                <p className="font-bold text-navy-900 border-t-2 border-navy-900 pt-2 w-48 mx-auto">Teslim Alan (Müşteri)</p>
                <p className="text-[10px] text-navy-500 mt-1 capitalize font-bold">{liveShare?.customerFirstName} {liveShare?.customerLastName}</p>
             </div>
             <div className="text-center">
                <p className="font-bold text-navy-900 border-t-2 border-navy-900 pt-2 w-48 mx-auto">Teslim Eden (Yetkili)</p>
                <p className="text-[10px] text-navy-500 mt-1 font-bold">Haşimoğlu Çiftliği / Muhasebe</p>
             </div>
          </div>

          <div className="mt-12 text-center text-[9px] text-navy-400 font-mono flex justify-between items-end border-t border-gray-100 pt-2">
             <div className="text-left">
                <p>İşbu evrak tahsilat makbuzu/proforma faturadır. Mali değeri yoktur.</p>
                <p className="mt-0.5 opacity-50">Sistem Üretimi Makbuz ID: {payment?.id}</p>
             </div>
             <p className="opacity-30">Haşimoğlu Kurban Yönetim Sistemi</p>
          </div>
       </div>
       </div>
    </div>
  );
}
